var tag = document.createElement('script');
tag.src = "//www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
var player = null;
var yTManager = {
	//defaults
	defaults: {height: '88',width: '152'},
	ytDump: {},
	ytProgressTracker: null,
	//is the yt api loaded
	youTubeApiLoaded: false,
	ytProgressTracker: null,
	videoId: null,
	WTVars: null,
	//this is an optional step to allow us to directly set the wt vars - normally we just ask for them and set them via the wtVars obj
	setWTVars: function(vars){
		this.WTVars = vars;		
	},
	getWTVars: function(){
		var i = this;
		if(i.WTVars == null){
			//we look for the WTVars obj
			if(typeof(WTVars) != "undefined"){
				i.WTVars = WTVars;
				
			} else {
				console.warn("yTManager cannot find WTVars");
				return;
			}
		}
		return i.WTVars;
	},
	loadYouTube: function(vars){
		//this needs to only run if the api is loaded, so we check for this
		var i = this;
		//we do the load vars here, so in the tracking we just refer to the object, not the method
		i.getWTVars();

		if(i.youTubeApiLoaded == true){

			i.loadYouTubeActual(vars);

		} else {
			//console.log('waiting for api resources');
			//we need wait till the yt api is loaded
			i.intVars = vars;

			i.checking = setInterval(function(){
				if(i.youTubeApiLoaded == true){
					i.loadYouTubeActual(i.intVars);
					clearInterval(i.checking);	
	
				}
				
				
			}, 500);
				
			
		}
	},
	loadYouTubeActual: function(vars){
		//so, we want to load this player
		var i = this;
		i.ytDump = {};
		i.lookup = {};
		i.lookup["-1"] = 'unstarted';
		i.lookup[YT.PlayerState.PLAYING] = "playing";
		i.lookup[YT.PlayerState.ENDED] = "ended";
		i.lookup[YT.PlayerState.PAUSED] = "paused";
		i.lookup[YT.PlayerState.BUFFERING] = "buffering";
		i.lookup[YT.PlayerState.CUED] = "cued";
		var required = ["videoId", "target"];
		for(var k in required){
			if(!vars.hasOwnProperty(required[k])){
				console.warn("No "+required[k]+" specified but loadYouTube called");
			}			
		}

		//default vars
		var settings = i.defaults;
		
		//merged vars
		for(var k in vars){
			settings[k] = vars[k];
		}
		i.videoId = settings.videoId;
		//we would set the html element externally, but right now, just getting working
		var vidElement = 'video'+i.videoId;
		//this part is to workaround IE not unloading the video, even if you just delete the iframe it will persist...
		if(player != null){
			//we've loaded a video before, so we 
			//clear the src
			$("#"+settings.target).find("iframe").attr("src","");
			//wait a bit, then ask YT to destroy the player
		 	setTimeout(function(){
	           player.destroy();
	           //now we load normally
       			i.loadNormal(vidElement, settings);

	       },100);
		} else {
			i.loadNormal(vidElement, settings);
		}

		//console.log(player);
	},
	loadNormal: function(vidElement, settings){
		//double up on IE stupidness
		var i = this;
		$("#"+settings.target).html('<div id="'+vidElement+'" class="yTvideo"></div>');
		player = new YT.Player(
			vidElement, 
			{
				height: settings.height,
				width: settings.width,
				videoId: settings.videoId,
				playerVars:{'autoplay':0, 'rel':0, 'showinfo':0, 'egm':0, 'showsearch':0,'wmode':'transparent',},
				events: {
					'onReady': onPlayerReady,
					'onStateChange': onPlayerStateChange,
					'onPlaybackQualityChange': onPlaybackQualityChange
				}
			}
		);
		i.wtYoutubeTrack('loaded');		
	},
	stopVideo: function() {
		//console.log('stopV');
		if(player != null){
			player.stopVideo();
			
		}
	},
	wtYoutubeTrack:function(action){
		var v = this.WTVars;
		action = v.base+'-'+action;
		dcsMultiTrack('DCS.dcsip', location.hostname, 'DCS.dcsuri', v.path, 'DCSext.video_action', action, 'DCSext.video_title', this.videoId, 'WT.dl', 31,'WT.sp',v.sp);
	    _tag.dcsCleanUp();
	},
	trackProgress:function(){
		var i = this;
		i.ytProgressTracker = setInterval(function(){
			var t = Math.round(player.getCurrentTime());
						//console.log(t);
	
			if(i.ytDump.hasOwnProperty(t)){
				i.wtYoutubeTrack(i.ytDump[t],i.youtube_id);
	
			}
	
		
		}, 1000);
	},
	noTrackProgress:function(){
		clearInterval(this.ytProgressTracker);
	}
};
function onPlayerReady(event) {
	var i = yTManager;
	var d = player.getDuration();
		//console.log(d);

	var div = (d/4);
	i.ytDump[0] = 'videoStarts';
	i.ytDump[Math.round(div)] = "videoProgress25";
	i.ytDump[Math.round(div*2)] = "videoProgress50";
	i.ytDump[Math.round(div*3)] = "videoProgress75";
	//ytDump["100%"] = div*4;



}
function onPlayerStateChange(event) {
		//console.log(event);

	var i = yTManager;

	if(i.lookup[event.data] == "playing"){
	
		i.trackProgress();
	} else {
		i.noTrackProgress();
		if(i.lookup[event.data] == "ended"){
	
			i.wtYoutubeTrack("videoProgress",i.videoId);
		}

	}

	/*if (event.data == YT.PlayerState.PLAYING && !done) {
	setTimeout(stopVideo, 6000);
	done = true;
	}*/
}

function onPlaybackQualityChange(q){
		//console.log(q);

	yTManager.wtYoutubeTrack("videoQuality"+q.data,yTManager.videoId);

}	
	

//this is called via the yt api
function onYouTubeIframeAPIReady() {
	yTManager.youTubeApiLoaded = true;
}


